module.exports = __webpack_public_path__ + "img/ic_logout_disabled.e9427d08.svg";